import { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import EntitySignupStep1 from "./entity-signup-step-1";
import EntitySignupStep2 from "./entity-signup-step-2";
import EntitySignupStep3 from "./entity-signup-step-3";
import NoRouteFound from "../no-route-found/no-route-found";
import { useSelector } from "react-redux";
import ErrorToast from "../../components/toasts/error-toast";
import SuccessToast from "../../components/toasts/success-toast";
import EntitySignupSucess from "./entity-signup-sucess";
import axiosInstance from "../../interceptors";
import WarningToast from "../../components/toasts/warning-toast";
import axios from "axios";
import { baseUrl } from "../../config/config";
import { image } from "../../components/assets/assets";

const entityStyles = `
  /* ============================================================
     ENTITY SIGNUP — Premium design matching login/signup pages
     ============================================================ */
  .entity-signup-wrapper {
    display: flex !important;
    height: 100vh !important;
    overflow: hidden !important;
    margin: 0 !important;
    padding: 0 !important;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif !important;
    -webkit-font-smoothing: antialiased;
  }

  /* ---- LEFT PANEL ---- */
  .entity-signup-left {
    width: 38% !important;
    min-width: 38% !important;
    max-width: 38% !important;
    height: 100vh !important;
    background: linear-gradient(135deg, #1e1b4b 0%, #312e81 25%, #3730a3 50%, #4c1d95 75%, #1e1b4b 100%) !important;
    background-size: 300% 300% !important;
    animation: esGradient 12s ease infinite !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    position: relative !important;
    overflow: hidden !important;
    padding: 40px 30px !important;
    box-sizing: border-box !important;
  }
  @keyframes esGradient {
    0%, 100% { background-position: 0% 50%; }
    25% { background-position: 100% 50%; }
    50% { background-position: 100% 0%; }
    75% { background-position: 0% 100%; }
  }

  /* Aurora */
  .es-aurora { position:absolute;inset:0;z-index:1;opacity:0.18;overflow:hidden;pointer-events:none; }
  .es-aurora::before {
    content:'';position:absolute;top:-50%;left:-50%;width:200%;height:200%;
    background:conic-gradient(from 0deg at 50% 50%,transparent 0deg,rgba(99,102,241,0.4) 60deg,transparent 120deg,rgba(139,92,246,0.35) 180deg,transparent 240deg,rgba(67,56,202,0.3) 300deg,transparent 360deg);
    animation:esAuroraRot 20s linear infinite;filter:blur(40px);
  }
  .es-aurora::after {
    content:'';position:absolute;top:-30%;left:-30%;width:160%;height:160%;
    background:conic-gradient(from 180deg at 50% 50%,transparent 0deg,rgba(196,181,253,0.3) 90deg,transparent 180deg,rgba(165,180,252,0.25) 270deg,transparent 360deg);
    animation:esAuroraRot 28s linear infinite reverse;filter:blur(50px);
  }
  @keyframes esAuroraRot { from{transform:rotate(0deg);} to{transform:rotate(360deg);} }

  /* Orbs */
  .es-orb{position:absolute;border-radius:50%;pointer-events:none;z-index:1;}
  .es-orb-1{width:280px;height:280px;top:-70px;right:-50px;background:radial-gradient(circle,rgba(139,92,246,0.22) 0%,transparent 70%);animation:esOrbFloat 14s ease-in-out infinite;}
  .es-orb-2{width:220px;height:220px;bottom:5%;left:-40px;background:radial-gradient(circle,rgba(99,102,241,0.20) 0%,transparent 70%);animation:esOrbFloat 16s ease-in-out infinite reverse;animation-delay:-4s;}
  .es-orb-3{width:150px;height:150px;top:35%;right:8%;background:radial-gradient(circle,rgba(167,139,250,0.18) 0%,transparent 70%);animation:esOrbFloat 12s ease-in-out infinite;animation-delay:-7s;}
  @keyframes esOrbFloat{0%,100%{transform:translate(0,0) scale(1);opacity:0.4;}50%{transform:translate(12px,-20px) scale(1.1);opacity:0.75;}}

  /* Grid */
  .es-grid{position:absolute;inset:-50px;z-index:1;opacity:0.04;pointer-events:none;background-image:linear-gradient(rgba(255,255,255,1) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,1) 1px,transparent 1px);background-size:60px 60px;mask-image:radial-gradient(ellipse 70% 70% at 50% 50%,black 20%,transparent 70%);-webkit-mask-image:radial-gradient(ellipse 70% 70% at 50% 50%,black 20%,transparent 70%);}

  /* Noise */
  .es-noise{position:absolute;inset:0;z-index:2;opacity:0.03;pointer-events:none;background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E");background-size:128px 128px;}

  /* Particles */
  .es-particle{position:absolute;border-radius:50%;z-index:3;pointer-events:none;opacity:0;}
  .es-particle.es-drift{animation:esDriftUp 16s linear infinite;}
  .es-particle.es-twinkle{animation:esTwinkle 3s ease-in-out infinite;}
  .es-particle:nth-child(1){width:4px;height:4px;background:rgba(255,255,255,0.3);top:90%;left:15%;animation-duration:16s;animation-delay:0s;}
  .es-particle:nth-child(2){width:3px;height:3px;background:rgba(196,181,253,0.5);top:85%;left:45%;animation-duration:14s;animation-delay:-2s;}
  .es-particle:nth-child(3){width:5px;height:5px;background:rgba(165,180,252,0.3);top:80%;left:70%;animation-duration:18s;animation-delay:-5s;}
  .es-particle:nth-child(4){width:3px;height:3px;background:rgba(255,255,255,0.25);top:92%;left:30%;animation-duration:20s;animation-delay:-1s;}
  .es-particle:nth-child(5){width:4px;height:4px;background:rgba(196,181,253,0.4);top:88%;left:78%;animation-duration:15s;animation-delay:-7s;}
  .es-particle:nth-child(6){width:3px;height:3px;background:rgba(255,255,255,0.35);top:95%;left:55%;animation-duration:22s;animation-delay:-3s;}
  .es-particle:nth-child(7){width:2px;height:2px;background:rgba(255,255,255,0.6);top:12%;left:20%;animation-duration:2.5s;animation-delay:0s;}
  .es-particle:nth-child(8){width:2px;height:2px;background:rgba(255,255,255,0.5);top:28%;left:75%;animation-duration:3.5s;animation-delay:-1.2s;}
  .es-particle:nth-child(9){width:2px;height:2px;background:rgba(255,255,255,0.4);top:58%;left:88%;animation-duration:4s;animation-delay:-2.5s;}
  .es-particle:nth-child(10){width:2px;height:2px;background:rgba(255,255,255,0.5);top:42%;left:8%;animation-duration:3s;animation-delay:-0.8s;}
  @keyframes esDriftUp{0%{opacity:0;transform:translateY(0);}8%{opacity:0.8;}92%{opacity:0.8;}100%{opacity:0;transform:translateY(-500px) translateX(25px);}}
  @keyframes esTwinkle{0%,100%{opacity:0.1;transform:scale(0.8);}50%{opacity:0.9;transform:scale(1.2);}}

  /* Stat cards */
  .es-stat{position:absolute;z-index:8;pointer-events:none;background:rgba(255,255,255,0.07);border:1px solid rgba(255,255,255,0.12);backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);border-radius:14px;padding:10px 14px;text-align:center;box-shadow:0 8px 32px rgba(0,0,0,0.12),inset 0 1px 0 rgba(255,255,255,0.08);}
  .es-stat-val{font-size:18px;font-weight:800;color:#fff;line-height:1;margin-bottom:2px;}
  .es-stat-lbl{font-size:8px;font-weight:500;color:rgba(255,255,255,0.6);text-transform:uppercase;letter-spacing:0.06em;white-space:nowrap;}
  .es-stat-1{top:8%;left:5%;animation:esStatF1 7s ease-in-out infinite;}
  .es-stat-2{top:12%;right:4%;animation:esStatF2 8s ease-in-out infinite;animation-delay:-2s;}
  .es-stat-3{bottom:10%;left:6%;animation:esStatF3 9s ease-in-out infinite;animation-delay:-4s;}
  @keyframes esStatF1{0%,100%{transform:translateY(0) rotate(0deg);}30%{transform:translateY(-10px) rotate(1.5deg);}70%{transform:translateY(-4px) rotate(-1deg);}}
  @keyframes esStatF2{0%,100%{transform:translateY(0) rotate(0deg);}40%{transform:translateY(-8px) rotate(-2deg);}80%{transform:translateY(-3px) rotate(1deg);}}
  @keyframes esStatF3{0%,100%{transform:translateY(0) rotate(0deg);}25%{transform:translateY(-12px) rotate(1deg);}60%{transform:translateY(-6px) rotate(-1.5deg);}}

  /* Feature badges */
  .es-badge{position:absolute;z-index:8;pointer-events:none;background:rgba(255,255,255,0.06);border:1px solid rgba(255,255,255,0.10);backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);border-radius:20px;padding:5px 12px;font-size:9px;font-weight:600;color:rgba(255,255,255,0.75);white-space:nowrap;display:flex;align-items:center;gap:4px;box-shadow:0 4px 16px rgba(0,0,0,0.08);}
  .es-badge-1{bottom:24%;right:3%;animation:esBadgeF 10s ease-in-out infinite;}
  .es-badge-2{top:36%;left:2%;animation:esBadgeF 12s ease-in-out infinite;animation-delay:-3s;}
  .es-badge-3{bottom:36%;left:8%;animation:esBadgeF 11s ease-in-out infinite;animation-delay:-6s;}
  .es-badge-4{top:28%;right:5%;animation:esBadgeF 9s ease-in-out infinite;animation-delay:-1.5s;}
  @keyframes esBadgeF{0%,100%{transform:translateY(0) translateX(0);}30%{transform:translateY(-8px) translateX(4px);}60%{transform:translateY(-12px) translateX(-3px);}85%{transform:translateY(-3px) translateX(2px);}}

  /* Glassmorphism illustration */
  .es-illus{position:relative;width:200px;height:150px;margin:0 auto 24px;z-index:5;}
  .es-illus-main{position:absolute;width:120px;height:85px;top:35px;left:40px;background:rgba(255,255,255,0.08);border:1px solid rgba(255,255,255,0.15);backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);border-radius:14px;animation:esShapeF1 6s ease-in-out infinite;box-shadow:0 8px 32px rgba(0,0,0,0.1);}
  .es-illus-main::before{content:'';position:absolute;top:14px;left:14px;right:14px;height:6px;background:rgba(255,255,255,0.25);border-radius:3px;}
  .es-illus-main::after{content:'';position:absolute;top:28px;left:14px;width:60px;height:4px;background:rgba(255,255,255,0.15);border-radius:2px;}
  .es-illus-sm1{position:absolute;width:60px;height:42px;top:12px;left:5px;background:rgba(139,92,246,0.20);border:1px solid rgba(139,92,246,0.25);border-radius:10px;animation:esShapeF2 5s ease-in-out infinite;animation-delay:-1.5s;}
  .es-illus-sm1::before{content:'';position:absolute;top:10px;left:10px;width:16px;height:16px;background:rgba(139,92,246,0.35);border-radius:6px;}
  .es-illus-sm2{position:absolute;width:65px;height:38px;top:20px;right:0;background:rgba(99,102,241,0.18);border:1px solid rgba(99,102,241,0.22);border-radius:10px;animation:esShapeF3 7s ease-in-out infinite;animation-delay:-3s;}
  .es-illus-sm2::before{content:'';position:absolute;top:10px;left:10px;right:10px;height:4px;background:rgba(99,102,241,0.30);border-radius:2px;}
  .es-illus-bar{position:absolute;width:140px;height:30px;bottom:5px;left:30px;background:rgba(255,255,255,0.06);border:1px solid rgba(255,255,255,0.10);border-radius:8px;animation:esShapeF1 8s ease-in-out infinite;animation-delay:-2s;display:flex;align-items:center;padding:0 10px;gap:6px;}
  .es-illus-dot{width:7px;height:7px;border-radius:50%;background:rgba(52,211,153,0.6);animation:esPulse 2s ease infinite;}
  .es-illus-line{flex:1;height:3px;background:rgba(255,255,255,0.12);border-radius:2px;}
  @keyframes esShapeF1{0%,100%{transform:translateY(0);}50%{transform:translateY(-8px);}}
  @keyframes esShapeF2{0%,100%{transform:translateY(0) rotate(0deg);}40%{transform:translateY(-6px) rotate(-1.5deg);}70%{transform:translateY(-12px) rotate(0.5deg);}}
  @keyframes esShapeF3{0%,100%{transform:translateY(0) translateX(0);}30%{transform:translateY(-5px) translateX(3px);}60%{transform:translateY(-12px) translateX(-2px);}}
  @keyframes esPulse{0%,100%{opacity:1;transform:scale(1);}50%{opacity:0.5;transform:scale(0.85);}}

  /* Brand */
  .entity-signup-left-brand{position:relative!important;z-index:10!important;text-align:center!important;max-width:300px!important;}
  .entity-signup-logo{max-width:90px!important;width:auto!important;height:auto!important;margin-bottom:16px!important;border-radius:10px!important;opacity:0.95;display:block!important;margin-left:auto!important;margin-right:auto!important;}
  .entity-signup-illustration{display:none!important;}
  .entity-signup-left-brand h2{color:#fff!important;font-size:22px!important;font-weight:700!important;margin-bottom:8px!important;letter-spacing:-0.4px!important;}
  .entity-signup-left-brand p{color:rgba(255,255,255,0.6)!important;font-size:12px!important;line-height:1.7!important;margin:0 auto!important;}

  /* ---- RIGHT PANEL ---- */
  .entity-signup-right {
    width: 62% !important;
    min-width: 62% !important;
    height: 100vh !important;
    background: #F8FAFC !important;
    display: flex !important;
    align-items: flex-start !important;
    justify-content: center !important;
    overflow-y: auto !important;
    padding: 24px 28px !important;
    box-sizing: border-box !important;
    position: relative !important;
  }
  .entity-signup-right::before {
    content:''!important;position:absolute!important;inset:0!important;
    background-image:radial-gradient(circle,rgba(99,102,241,0.07) 1px,transparent 1px)!important;
    background-size:32px 32px!important;opacity:0.35!important;pointer-events:none!important;
    mask-image:radial-gradient(ellipse 50% 50% at 50% 50%,black 10%,transparent 70%);
    -webkit-mask-image:radial-gradient(ellipse 50% 50% at 50% 50%,black 10%,transparent 70%);
  }

  /* ---- CARD ---- */
  .entity-signup-card {
    max-width: 700px !important;
    width: 100% !important;
    background: #fff !important;
    border-radius: 20px !important;
    padding: 28px 32px 24px !important;
    box-shadow: 0 8px 32px rgba(0,0,0,0.07), 0 2px 8px rgba(0,0,0,0.03) !important;
    border: 1px solid #E2E8F0 !important;
    position: relative !important;
    z-index: 2 !important;
    box-sizing: border-box !important;
    margin: 16px 0 !important;
  }

  /* Labels above inputs */
  .entity-signup-card .input-field,
  .entity-signup-card .es-field {
    display: flex !important;
    flex-direction: column !important;
    margin-top: 0 !important;
    margin-bottom: 10px !important;
  }
  .entity-signup-card .input-field label,
  .entity-signup-card label {
    position: static !important;
    transform: none !important;
    font-size: 12px !important;
    font-weight: 600 !important;
    color: #475569 !important;
    letter-spacing: 0.01em !important;
    margin-bottom: 5px !important;
    order: -1 !important;
    width: fit-content !important;
    left: auto !important;
    top: auto !important;
  }

  /* Hide icons */
  .entity-signup-card .place-icon-left,
  .entity-signup-card .place-icon-right,
  .entity-signup-card .view-password {
    display: none !important;
  }

  /* Inputs */
  .entity-signup-card input:not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="file"]),
  .entity-signup-card .select-wrapper input.select-dropdown,
  .entity-signup-card textarea {
    background: #F8FAFC !important;
    border: 1.5px solid #E2E8F0 !important;
    border-radius: 8px !important;
    height: 42px !important;
    padding: 0 14px !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    font-family: 'Inter', sans-serif !important;
    color: #1E293B !important;
    box-shadow: 0 1px 2px rgba(0,0,0,0.04) !important;
    outline: none !important;
    transition: all 0.25s cubic-bezier(0.16,1,0.3,1) !important;
    box-sizing: border-box !important;
    margin: 0 !important;
    width: 100% !important;
  }
  .entity-signup-card textarea { height: auto !important; padding: 10px 14px !important; min-height: 80px !important; }
  .entity-signup-card input:focus,
  .entity-signup-card textarea:focus,
  .entity-signup-card .select-wrapper input.select-dropdown:focus {
    background: #fff !important;
    border-color: #7B5AC4 !important;
    box-shadow: 0 0 0 3px rgba(99,102,241,0.15), 0 1px 2px rgba(0,0,0,0.04) !important;
  }
  .entity-signup-card input::placeholder { color: #94A3B8 !important; font-weight: 400 !important; }

  /* Buttons */
  .entity-signup-card .btn,
  .entity-signup-card .btn-large,
  .entity-signup-card .btn-submit,
  .entity-signup-card .btn.btn-submit {
    height: 44px !important;
    line-height: 44px !important;
    border: none !important;
    border-radius: 10px !important;
    background: linear-gradient(135deg, #7B5AC4 0%, #8B5CF6 100%) !important;
    color: #fff !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    font-family: 'Inter', sans-serif !important;
    cursor: pointer !important;
    box-shadow: 0 4px 14px rgba(99,102,241,0.35) !important;
    transition: all 0.3s cubic-bezier(0.16,1,0.3,1) !important;
    text-transform: none !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 0 24px !important;
  }
  .entity-signup-card .btn:hover,
  .entity-signup-card .btn-submit:hover {
    background: linear-gradient(135deg, #6A4DB3 0%, #7C3AED 100%) !important;
    box-shadow: 0 8px 25px rgba(99,102,241,0.45) !important;
    transform: translateY(-1px) !important;
  }
  .entity-signup-card .btn-clear,
  .entity-signup-card .btn.btn-clear,
  .entity-signup-card .add-contact-person-btn {
    background: #fff !important;
    color: #7B5AC4 !important;
    border: 1.5px solid #E2E8F0 !important;
    box-shadow: none !important;
    border-radius: 10px !important;
  }
  .entity-signup-card .btn-clear:hover,
  .entity-signup-card .add-contact-person-btn:hover {
    background: #EEF2FF !important;
    border-color: #7B5AC4 !important;
    box-shadow: none !important;
    transform: none !important;
  }

  /* Headings */
  .entity-signup-card h2, .entity-signup-card h3 { color: #1E293B !important; font-weight: 700 !important; }

  /* Sections */
  .es-header { display:flex; justify-content:space-between; align-items:center; margin-bottom:16px; padding-bottom:14px; border-bottom:1px solid #E2E8F0; }
  .es-header h2 { font-size: 20px !important; }
  .es-steps { background:rgba(99,102,241,0.08)!important; padding:4px 14px; border-radius:20px; font-size:13px!important; color:#7B5AC4!important; }
  .es-steps strong { color:#7B5AC4!important; font-weight:700; }
  .es-section-title { font-size:13px!important; font-weight:700!important; color:#1E293B!important; margin:16px 0 6px 0!important; text-transform:uppercase; letter-spacing:0.5px; }
  .es-divider { border:none; border-top:1px solid #E2E8F0; margin:18px 0 10px; }
  .es-actions { display:flex; justify-content:flex-end; align-items:center; gap:12px; margin-top:20px; padding-top:16px; border-top:1px solid #E2E8F0; }

  /* Grid */
  .es-grid { display:grid!important; gap:10px 14px!important; }
  .es-grid-1 { grid-template-columns:1fr!important; max-width:320px!important; }
  .es-grid-2 { grid-template-columns:repeat(2,1fr)!important; }
  .es-grid-3 { grid-template-columns:repeat(3,1fr)!important; }

  /* Contact card */
  .es-contact-card { background:#F8FAFC!important; border:1px solid #E2E8F0!important; border-radius:12px!important; padding:16px 16px 8px!important; margin-bottom:10px!important; }

  /* Progress steps */
  .es-progress { display:flex; align-items:center; justify-content:center; margin:14px 0 20px; }
  .es-step { width:38px; height:38px; border-radius:50%; background:#F1F5F9; border:2px solid #E2E8F0; display:flex; align-items:center; justify-content:center; flex-shrink:0; }
  .es-step.active { background:#7B5AC4!important; border-color:#7B5AC4!important; }
  .es-step img { width:16px; height:16px; }
  .es-step-line { width:48px; height:2px; background:#E2E8F0; }

  /* Verify */
  .entity-signup-card .verify .text { color:#7B5AC4!important; font-weight:600!important; font-size:12px!important; }
  .entity-signup-card .verify .status { color:#10B981!important; font-weight:600!important; font-size:12px!important; }

  /* Responsive */
  @media (max-width:1100px) {
    .es-grid-3 { grid-template-columns:repeat(2,1fr)!important; }
    .entity-signup-left { width:32%!important; min-width:32%!important; max-width:32%!important; }
    .entity-signup-right { width:68%!important; min-width:68%!important; }
  }
  @media (max-width:992px) {
    .entity-signup-wrapper { flex-direction:column!important; height:auto!important; overflow-y:auto!important; }
    .entity-signup-left { width:100%!important; min-width:100%!important; max-width:100%!important; height:200px!important; padding:20px!important; }
    .es-stat,.es-badge,.es-illus { display:none!important; }
    .entity-signup-right { width:100%!important; min-width:100%!important; height:auto!important; padding:20px 16px!important; }
    .entity-signup-card { padding:24px 20px!important; }
  }
  @media (max-width:600px) {
    .entity-signup-left { display:none!important; }
    .entity-signup-right { width:100%!important; min-width:100%!important; }
    .entity-signup-card { border-radius:12px!important; padding:20px 16px!important; }
    .es-grid-3,.es-grid-2 { grid-template-columns:1fr!important; }
    .es-actions { flex-direction:column!important; }
  }
`;

const EntitySignupScreen = () => {
  const { successMessage, failMessage } = useSelector(
    (state) => state.signUpReducer
  );

  const [newEntity, setNewEntity] = useState({
    entityType: "Employer/Corporate",
    businessName: "",
    businessShortName: "",
    hqstate: "",
    hqcity: "",
    pincode: "",
    country: "",
    webSite: "https://",
    noOfEmployees: "",
    contactPersonDetails: [
      {
        id: null,
        firstName: "",
        lastName: "",
        whatsappNumberCountryCode: "",
        whatsappNumber: "",
        whatsappNumberVerified: false,
        email: "",
        designation: "",
        linkdinUrl: "",
        mobileNumberCountryCode: "",
        mobileNumber: "",
        mobileNumberVerified: false,
        password: "",
        confirmPassword: "",
      },
    ],

    billingAddress: [
      {
        addressLine1: "",
        addressLine2: "",
        stateId: "",
        id: null,
        orgId: "",
        pincode: "",
        name: "",
        cinNumber: "",
        panNumber: "",
        gstinNumber: "",
        gstState: "",
        panMedia: null,
        gstinMedia: null,
      },
    ],

    linkedinUrl: "",
    youTubeURL: "",
    logoMedia: null,
    primaryColor: "",
    secondaryColor: "",
    about: "",
    tfStatus: false,
    captchaVerified: false,
  });

  function isNumeric(str) {
    return /^[0-9]+$/.test(str);
  }
  const checkUniqueBusinessName = async (e) => {
    const { name, value } = e.target;
    if (value === "") {
      return WarningToast("Business name cannot be empty!");
    }
    if (isNumeric(value)) {
      ErrorToast("Business Name must contain atleast one Character");
      return;
    }
    try {
      const { data } = await axiosInstance.post(
        `${baseUrl}/common/base/newEntityRegistration/check-unique-business-name`,
        {
          name: value,
          entityId: localStorage?.getItem("entityId"),
        }
      );

      if (data.success || data.message) {
        if (data.message === "Name already exists") {
          ErrorToast(data.message || "Enter Unique Business Name");
        }
      }
    } catch (error) {
      ErrorToast(error.message || "Could not Verify Business Name");
    }
  };

  const checkUniqueWebsiteUrl = async (URL) => {
    if (URL === "") {
      return;
    }
    try {
      const { data } = await axiosInstance.post(
        `${baseUrl}/common/base/newEntityRegistration/validate-website`,
        {
          name: URL,
          entityId: localStorage?.getItem("entityId"),
        }
      );

      if (data.success || data.message) {
        if (data.message !== "Website URL is valid and unique") {
          ErrorToast(data.message || "Enter Unique Business Name");
        }
      }
    } catch (error) {
      ErrorToast(error.message || "Could not Verify Business Name");
    }
  };
  const checkValidPinCode = async (e) => {
    const pincode = e.target.value;
    if (pincode === "") {
      return WarningToast("Pin code cannot be empty!");
    }
    try {
      const { data } = await axios.post(
        `${baseUrl}/common/city/validate-pincode`,
        {
          id: newEntity.hqcity,
          pincode: pincode,
        }
      );
    } catch (error) {
      ErrorToast(error.message || "Could not validate Pin Code");
    }
  };

  const handleOnChangeEntityData = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setNewEntity(() => ({ ...newEntity, [name]: files[0] }));
    } else {
      setNewEntity(() => ({
        ...newEntity,
        [name]: value,
      }));
    }
  };

  useEffect(() => {
    if (failMessage) {
      ErrorToast(failMessage);
    } else if (successMessage) {
      SuccessToast(successMessage);
    }
  }, [successMessage, failMessage]);

  return (
    <>
      <style>{entityStyles}</style>
      <div className="entity-signup-wrapper">
        {/* Left Panel */}
        <div className="entity-signup-left">
          <div className="es-aurora"></div>
          <div className="es-orb es-orb-1"></div>
          <div className="es-orb es-orb-2"></div>
          <div className="es-orb es-orb-3"></div>
          <div className="es-grid"></div>
          <div className="es-noise"></div>

          <div className="es-particle es-drift"></div>
          <div className="es-particle es-drift"></div>
          <div className="es-particle es-drift"></div>
          <div className="es-particle es-drift"></div>
          <div className="es-particle es-drift"></div>
          <div className="es-particle es-drift"></div>
          <div className="es-particle es-twinkle"></div>
          <div className="es-particle es-twinkle"></div>
          <div className="es-particle es-twinkle"></div>
          <div className="es-particle es-twinkle"></div>

          <div className="es-stat es-stat-1"><div className="es-stat-val">10,000+</div><div className="es-stat-lbl">Interviews Conducted</div></div>
          <div className="es-stat es-stat-2"><div className="es-stat-val">500+</div><div className="es-stat-lbl">Companies Trust Us</div></div>
          <div className="es-stat es-stat-3"><div className="es-stat-val">98%</div><div className="es-stat-lbl">Time Saved</div></div>

          <div className="es-badge es-badge-1"><span>&#9889;</span> AI-Powered Scoring</div>
          <div className="es-badge es-badge-2"><span>&#127909;</span> Video Interviews</div>
          <div className="es-badge es-badge-3"><span>&#128202;</span> Smart Analytics</div>
          <div className="es-badge es-badge-4"><span>&#128197;</span> Auto Scheduling</div>

          <div className="entity-signup-left-brand">
            <img
              className="entity-signup-logo"
              src={image.brandStrategicPartnerLogo}
              alt="Ample Hire"
            />
            <img
              className="entity-signup-illustration"
              src={image.entitySignupPageImage}
              alt=""
            />
            <div className="es-illus">
              <div className="es-illus-sm1"></div>
              <div className="es-illus-sm2"></div>
              <div className="es-illus-main"></div>
              <div className="es-illus-bar"><div className="es-illus-dot"></div><div className="es-illus-line"></div></div>
            </div>
            <h2>Register Your Organization</h2>
            <p>
              Set up your company profile, add team members, and start hiring
              top talent with Ample Hire.
            </p>
          </div>
        </div>

        {/* Right Panel */}
        <div className="entity-signup-right">
          <div className="entity-signup-card">
            <Routes>
              <Route
                path="/step-1"
                element={
                  <EntitySignupStep1
                    newEntity={newEntity}
                    setNewEntity={setNewEntity}
                    handleOnChangeEntityData={handleOnChangeEntityData}
                    checkUniqueBusinessName={checkUniqueBusinessName}
                    checkUniqueWebsiteUrl={checkUniqueWebsiteUrl}
                    checkValidPinCode={checkValidPinCode}
                  />
                }
              />
              <Route
                path="/step-2"
                element={
                  <EntitySignupStep2
                    newEntity={newEntity}
                    setNewEntity={setNewEntity}
                    handleOnChangeEntityData={handleOnChangeEntityData}
                  />
                }
              />
              <Route
                path="/step-3"
                element={
                  <EntitySignupStep3
                    newEntity={newEntity}
                    setNewEntity={setNewEntity}
                    handleOnChangeEntityData={handleOnChangeEntityData}
                  />
                }
              />
              <Route path="/success" element={<EntitySignupSucess />} />
              <Route
                path="/*"
                element={<NoRouteFound navigateToPath={"/"} />}
              />
            </Routes>
          </div>
        </div>
      </div>
    </>
  );
};

export default EntitySignupScreen;
